angular.module('logbook')
    .directive('pageSelect', function() {
      return {
        restrict: 'E',
        template: '<input type="text" style="width: 3em; border-radius: 4px; font-size: small; margin: -10px 0; padding: 2px;" ng-model="inputPage" ng-change="selectPage(inputPage)">',
        link: function(scope, element, attrs) {
          scope.$watch('currentPage', function(c) {
            scope.inputPage = c;
          });
        }
      }
    });